<!-- Input Section -->
<div class="row mb-3">
  <label for="itemInput" class="col-sm-3 col-form-label">{{label | transloco}}:</label>
  <div class="col-sm-9">
    <div class="input-group">
      <input
          id="itemInput"
          type="text"
          class="form-control"
          [(ngModel)]="currentInput"
          (keydown.enter)="onEnterPressed($event)"
          [placeholder]="label | transloco"
          aria-label="item input">
      <button
          class="btn btn-outline-primary"
          type="button"
          (click)="addItem()"
          [disabled]="!currentInput.trim()">
        <i class="bi bi-plus-lg"></i> Add
      </button>
    </div>

    <div *ngIf="errorMessage" class="mt-1 text-warning">
      {{ errorMessage | transloco }}
    </div>

    <div class="my-2 d-flex flex-wrap gap-2">
          <span *ngFor="let item of values; let i = index"
                class="badge badge-primary-outline fs-6 d-flex align-items-center gap-1 px-2 py-1">
            {{ item }}
            <fa-icon class="hover-danger ms-2 h2" [icon]="removeIcon"
                     (click)="removeItem(i)">
            </fa-icon>
          </span>
    </div>
  </div>
</div>
